import axios from "axios";

const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  //baseURL :"http://192.168.50.62:8002"
});

Api.interceptors.request.use(function (response) {
  const token = localStorage.getItem("token");
  if (token !== undefined && token !== null) {
    response.headers["Authorization"] = `${token}`;
  }
  return response;
});

Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location =
        window.location.protocol + "//" + window.location.host + "/";
      localStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default Api;
